import { StatusChip, type ChipTone } from '@/components/sales/StatusChip';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type {
  MigrationReport,
  MigrationRmOutcome,
  MigrationRmResult,
} from '@/services/migration.service';

import { MigrationIssueList } from './MigrationIssueList';

const OUTCOME_TONE: Record<MigrationRmOutcome, ChipTone> = {
  existing: 'info',
  create: 'warning',
  rejected: 'destructive',
};

interface MigrationRmTableProps {
  rms: MigrationRmResult[];
  mode: MigrationReport['mode'];
}

const outcomeLabel = (outcome: MigrationRmOutcome, mode: MigrationReport['mode']): string => {
  if (outcome === 'existing') return 'Already in CRM';
  if (outcome === 'rejected') return 'Not added';
  return mode === 'commit' ? 'Sent for approval' : 'Will need approval';
};

export const MigrationRmTable = ({ rms, mode }: MigrationRmTableProps) => {
  if (rms.length === 0) {
    return <p className="py-10 text-center text-sm text-muted-foreground">No RMs in the workbook.</p>;
  }
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>RM Code</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Job Role</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="min-w-[340px]">Notes</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rms.map((rm) => (
            <TableRow key={rm.rmCode} className="align-top">
              <TableCell className="font-mono text-xs">
                <p className="font-semibold">{rm.rmCode}</p>
                <p className="text-muted-foreground">{`Row ${rm.sheetRows.join(', ')}`}</p>
              </TableCell>
              <TableCell className="font-semibold">{rm.name}</TableCell>
              <TableCell className="text-xs">{rm.jobRole}</TableCell>
              <TableCell>
                <StatusChip tone={OUTCOME_TONE[rm.outcome]}>{outcomeLabel(rm.outcome, mode)}</StatusChip>
              </TableCell>
              <TableCell>
                <MigrationIssueList issues={rm.issues} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
